import { useActiveCategory } from "~/composables/useActiveCategory";

export default defineNuxtRouteMiddleware(() => {
  const { setActiveCategoryId } = useActiveCategory();
  const { setActiveCategory } = useBrandNavigation();
  if (import.meta.server) {
    setActiveCategoryId(null);
    setActiveCategory(null);
  }
});
